import { objectSelector } from 'theme/utils';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/signup`);

class SignupRejected {
  constructor(model) {
    const {
      firstName,
      lastName,
      confirm,
      dateOfBirth,
      email,
      verificationCode,
      password,
      phone,
      apiError,
      gender,
      tomPayAllowed,
      detail
    } = model;

    this.firstName = firstName;
    this.lastName = lastName;
    this.confirm = confirm;
    this.dateOfBirth = dateOfBirth;
    this.password = password;
    this.phone = phone;
    this.email = email;
    this.verificationCode = verificationCode;
    this.apiError = apiError;
    this.gender = gender;
    this.tomPayAllowed = tomPayAllowed;
    this.detail = detail
  }
}

export const signupRejectedMapper = (item) => {
  return new SignupRejected({
    email: objectSelector(item, $P.ERROR_MESSAGES.EMAIL),
    firstName: objectSelector(item, $P.ERROR_MESSAGES.FIRST_NAME),
    lastName: objectSelector(item, $P.ERROR_MESSAGES.LAST_NAME),
    phone: objectSelector(item, $P.ERROR_MESSAGES.PHONE_NUMBER),
    password: objectSelector(item, $P.ERROR_MESSAGES.PASSWORD),
    confirm: objectSelector(item, $P.ERROR_MESSAGES.CONFIRM),
    dateOfBirth: objectSelector(item, $P.ERROR_MESSAGES.DATE_OF_BIRTH),
    verificationCode: objectSelector(item, $P.ERROR_MESSAGES.VERIFICATION_CODE),
    apiError: objectSelector(item, $P.ERROR_MESSAGES.API_ERROR),
    gender: objectSelector(item, $P.ERROR_MESSAGES.GENDER),
    tomPayAllowed: objectSelector(item, $P.ERROR_MESSAGES.TOM_PAY_ALLOWED),
    detail: objectSelector(item, $P.ERROR_MESSAGES.DETAIL)
  });
};



// WEBPACK FOOTER //
// ./src/models/signupRejected.js